import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getRegisteredUsers, confirmDeleteRegisteredUser, getInvitedUsers } from '../../services/authService';
import { getCookie } from "../../utils/cookieUtil";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


const LoadingSpinner = () => (
    <div className="fixed inset-0 flex h-full items-center justify-center  bg-opacity-50 z-50">
        <div className="w-16 h-16 border-t-4 border-[#900028] border-solid rounded-full animate-spin"></div>
    </div>
);

function AllUsers({ counter, searchMailQuery, selectedGroup, onExportRef }) {
    const [registeredUsers, setRegisteredUsers] = useState([]);
    const [invitedUsers, setInvitedUsers] = useState([]);
    const [loading, setDataLoading] = useState(false);
    const [permission, setPermission] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const itemsPerPage = 10;
    const navigate = useNavigate();
    const dropdownRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);




    useEffect(() => {
        fetchUsers();
        fetchInvitedUsers();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [searchMailQuery,]);

    useEffect(() => {
        fetchUsers();
        fetchInvitedUsers();
    }, [counter, searchMailQuery, selectedGroup]);

    useEffect(() => {
        const roles = getCookie('roleId');
        if (roles) {
            setPermission(roles);
        }
    }, []);

    const toggleDropdown = (uid) => {
        setActiveDropdown((prev) => (prev === uid ? null : uid));
    };

    const fetchUsers = async () => {
        setDataLoading(true);
        try {
            const res = await getRegisteredUsers();
            const data = await res.json();
            setRegisteredUsers(data.users);
        } catch (error) {
            console.error('Error fetching registered users:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const fetchInvitedUsers = async () => {
        setDataLoading(true);
        try {
            const res = await getInvitedUsers();
            const data = await res.json();
            setInvitedUsers(data.users);
        } catch (error) {
            console.error('Error fetching invited users:', error);
        } finally {
            setDataLoading(false);
        }
    };








    const handleViewClick = (uid) => {
        navigate(`/app/userdetails?uid=${uid}`);
    };

    // const handleDeleteClick = (uid) => {
    // setUserToDelete(uid);
    // setShowConfirmationModal(true);
    // };

    const confirmDelete = async () => {
        try {
            setDataLoading(true);
            await confirmDeleteRegisteredUser(userToDelete);
            setShowConfirmationModal(false);
            setUserToDelete(null);
            fetchUsers();
        } catch (error) {
            console.error('[ERROR] Failed to complete deletion process:', error);
        } finally {
            setDataLoading(false);
        }
    };

    const cancelDelete = () => {
        setShowConfirmationModal(false);
        setUserToDelete(null);
    };

    const allUsers = [
        ...registeredUsers.map(user => ({
            uid: user._id || user.uid, // use whatever unique ID field is available
            email: user.email,
            firstName: user.name?.firstName,
            secondName: user.name?.secondName,
            group: user.group,
        })),
        ...invitedUsers.map(user => ({
            uid: user._id || user.uid, // fallback to email if no uid
            email: user.email,
            firstName: user.firstName,
            secondName: user.secondName,
            group: user.group,
        }))
    ];

    const filteredUsers = allUsers.filter(user => {
        const emailMatch = user?.email?.toLowerCase().includes(searchMailQuery.toLowerCase());
        const groupMatch = selectedGroup && selectedGroup !== "All Groups"
            ? user?.group?.toLowerCase().includes(selectedGroup.toLowerCase())
            : true;
        return emailMatch && groupMatch;
    });



    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentUsers = filteredUsers.slice(startIndex, startIndex + itemsPerPage);
    const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);





    const handleShare = () => {
        const dataToExport = filteredUsers.map((user) => {
            const row = { Group: user.group };

            if (permission.includes("adduser")) {
                row["First Name"] = user.firstName;
                row["Last Name"] = user.secondName;
                row["Email"] = user.email;
            }

            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(dataToExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "all Users");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "all_users.xlsx");
    };
    useEffect(() => {
        if (onExportRef) {
            onExportRef.current = handleShare;
        }
    }, [onExportRef, filteredUsers, permission]);








    return (

        <div className="flex-1 relative  overflow-x-autopx-4 py-4" ref={dropdownRef}>


            <div className="relative w-full ">
                <table className="w-full table-fixed text-sm text-left text-gray-900">
                    <thead className="text-xs bg-gray-200 uppercase">
                        <tr>
                            <th className="w-8 p-2"></th>

                            {permission.includes("adduser") && (
                                <>
                                    <th className="w-32 px-2 py-2 whitespace-nowrap">FIRST NAME</th>
                                    <th className="w-32 px-2 py-2 whitespace-nowrap">LAST NAME</th>
                                    <th className="w-48 px-2 py-2 truncate">EMAIL</th>
                                </>
                            )}

                            <th className="w-32 px-2 py-2">GROUP</th>
                            <th className="w-12 px-2 py-2 text-center"></th>
                        </tr>
                    </thead>

                    <tbody>
                        {currentUsers.map((user) => (
                            <tr key={user.uid} className="border-b hover:bg-gray-50 text-xs">
                                <td className="p-4"></td>

                                {permission.includes("adduser") && (
                                    <>
                                        <td className="px-2 py-1 truncate">  {user.firstName?.charAt(0).toUpperCase() + user.firstName?.slice(1)}</td>
                                        <td className="px-2 py-1 truncate">  {user.secondName?.charAt(0).toUpperCase() + user.secondName?.slice(1)}</td>
                                        <td className="px-2 py-1 truncate">{user.email}</td>
                                    </>
                                )}

                                <td className="px-2 py-1 truncate">{user.group}</td>

                                <td className="px-2 py-1 text-center relative">
                                    {/* Uncomment and hook up if dropdown actions needed */}
                                    {/* <div className="inline-block text-left">
            <button
              className="text-gray-600 hover:bg-gray-200 p-1 rounded"
              onClick={() => toggleDropdown(user.uid)}
            >
              &#x22EE;
            </button>

            {activeDropdown === user.uid && (
              <div className="absolute right-0 z-10 mt-2 w-24 bg-white border rounded shadow">
                <button
                  className="block w-full px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => handleViewClick(user.uid)}
                >
                  View
                </button>
                <button
                  className="block w-full px-4 py-2 text-sm hover:bg-gray-100"
                  onClick={() => handleDeleteClick(user.uid)}
                >
                  Delete
                </button>
              </div>
            )}
          </div> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

            </div>


            {/* Pagination */}
            <div className="flex justify-center items-center mt-4 gap-1">
                {(() => {
                    const maxVisible = 6;
                    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                    let end = start + maxVisible - 1;
                    if (end > totalPages) {
                        end = totalPages;
                        start = Math.max(1, end - maxVisible + 1);
                    }

                    const pages = [];
                    for (let i = start; i <= end; i++) {
                        pages.push(
                            <button
                                key={i}
                                onClick={() => setCurrentPage(i)}
                                className={`px-2 py-1 text-xs sm:text-sm rounded ${currentPage === i
                                    ? "font-bold text-black"
                                    : "text-gray-700 hover:bg-gray-200"
                                    }`}
                            >
                                {i}
                            </button>
                        );
                    }
                    return pages;
                })()}
                <button
                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className={`px-2 py-1 flex items-center ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "hover:bg-gray-100"
                        }`}
                >
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>

            {/* Confirmation Modal */}
            {
                showConfirmationModal && (
                    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 backdrop-blur-sm flex items-center justify-center px-4">
                        <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-xs sm:max-w-sm md:max-w-md xl:max-w-lg p-5 transition-all duration-300 animate-fade-in">
                            <h3 className="text-base sm:text-lg md:text-xl font-semibold text-gray-900 mb-3">Confirm Deletion</h3>
                            <p className="text-gray-600 mb-6 text-sm sm:text-base">
                                Are you sure you want to permanently delete this user?
                            </p>
                            <div className="flex justify-end gap-3">
                                <button
                                    onClick={cancelDelete}
                                    className="px-3 sm:px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={() => confirmDelete(userToDelete)}
                                    className="px-3 sm:px-4 py-2 text-sm font-semibold text-white bg-red-600 hover:bg-red-700 rounded-lg"
                                >
                                    Yes, Delete
                                    {loading && <LoadingSpinner />}
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
  {loading && <LoadingSpinner />}
        </div >

    );

}

export default AllUsers;











